import { render, staticRenderFns } from "./HomeworkNoteImage.vue?vue&type=template&id=645ae06b&scoped=true"
import script from "./HomeworkNoteImage.vue?vue&type=script&lang=js"
export * from "./HomeworkNoteImage.vue?vue&type=script&lang=js"
import style0 from "./HomeworkNoteImage.vue?vue&type=style&index=0&id=645ae06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ae06b",
  null
  
)

export default component.exports